module.exports = __webpack_public_path__ + "static/these-truths-a-history-of-the-united-states-f07b99a868774156c1bbc9d67f0f8ef5.jpg";